require('./ruleActionGroup.i18n.json');
require('./ruleActionGroup.tpl.html');
require('./ruleActionGroupController.js');

const RuleActionGroupComponent = {
    templateUrl: '/common/rule/ruleActionGroup/ruleActionGroup.tpl.html',
    controller: 'ruleActionGroupController',
    bindings: {
        ruleActionGroup: '<',
        ruleSetName: '<',
        onDeleteSubAction: '&',
        canUserManageFormRules: '<'
    }
};

angular.module('ums')
    .component('uiRuleActionGroup', RuleActionGroupComponent);
